<script>
import {mapState} from 'vuex';

import FormField from 'components/FormField';

export default {
    components: {
        FormField,
    },
    data: () => ({
        loading: false,
    }),
    computed: {
        ...mapState({
            register: state => state.account.register,
            return_address: state => state.account.register.return_address,
            email: state => state.account.register.email,
            password: state => state.account.register.password,
            confirm: state => state.account.register.confirm,
            first_name: state => state.account.register.first_name,
            last_name: state => state.account.register.last_name,
            company_url: state => state.account.register.company_url,
            company_name: state => state.account.register.company_name,
            addressee: state => state.account.register.return_address.addressee,
            street_1: state => state.account.register.return_address.street_1,
            street_2: state => state.account.register.return_address.street_2,
            city: state => state.account.register.return_address.city,
            province: state => state.account.register.return_address.province,
            country: state => state.account.register.return_address.country,
            postal_code: state => state.account.register.return_address.postal_code,
        }),
    },
    methods: {
        async handleSubmit() {
            this.loading = true;

            try {
                await this.$store.dispatch('register');

                this.loading = false;
            } catch (e) {
                this.loading = false;
            }
        },
    },
};
</script>

<template lang='pug'>
    .mx-auto.w-11-12.lg_w-1-2.xxl_w-5-12.my-2.lg_my-4

        .text-lg.lg_text-2xl.dark-mode_text-secondary-200.text-secondary.text-center.block Already have an account? #[router-link.text-primary(:to='{ name: "root" }') Sign In]

        observe(v-slot='{ passes }')
            form(@submit.prevent='passes(handleSubmit)')
                .flex
                    form-field.mr-_25.w-1-2(
                        label='First Name',
                        rules='required|min:1',
                        :value='first_name',
                        @input='updateState(register, "first_name", $event)',
                    )

                    form-field.ml-_25.w-1-2(
                        label='Last Name',
                        rules='required|min:1',
                        :value='last_name',
                        @input='updateState(register, "last_name", $event)',
                    )

                .flex
                    form-field.mr-_25.w-1-2(
                        label='Company Name',
                        rules='required|min:2',
                        :value='company_name',
                        @input='updateState(register, "company_name", $event)',
                    )

                    form-field.ml-_25.w-1-2(
                        label='Company URL',
                        rules='required|url',
                        :value='company_url',
                        @input='updateState(register, "company_url", $event)',
                    )

                form-field.mt-1(
                    label='Recipient',
                    rules='required|min:1|alpha_spaces',
                    :value='addressee',
                    @input='updateState(return_address, "addressee", $event)',
                )

                .flex
                    .w-2-3.mr-_25
                        form-field(
                            label='Address',
                            rules='required|min:3|max:200',
                            :value='street_1',
                            @input='updateState(return_address, "street_1", $event)',
                        )
                    .w-1-3.ml-_25
                        form-field(
                            label='Address 2',
                            rules='min:3|max:200',
                            :value='street_2',
                            @input='updateState(return_address, "street_2", $event)',
                        )

                .flex
                    form-field.mr-_25.w-1-2(
                        label='City / Town',
                        rules='required|min:2|max:200|alpha_spaces',
                        :value='city',
                        @input='updateState(return_address, "city", $event)',
                    )
                    form-field.ml-_25.w-1-2(
                        label='State / Province / Region',
                        rules='required|min:2|max:200|alpha_spaces',
                        :value='province',
                        @input='updateState(return_address, "province", $event)',
                    )

                .flex
                    form-field.mr-_25.w-1-2(
                        label='Zip / Postal Code',
                        rules='required|min:2|max:20|alpha_dash',
                        :value='postal_code',
                        @input='updateState(return_address, "postal_code", $event)',
                    )
                    form-field.ml-_25.w-1-2(
                        label='Country',
                        rules='required|min:2|max:200|alpha_spaces',
                        :value='country',
                        @input='updateState(return_address, "country", $event)',
                    )

                form-field.mt-1(
                    label='Email',
                    rules='required|email',
                    :value='email',
                    @input='updateState(register, "email", $event)',
                )

                form-field(
                    password-reveal,
                    type='password',
                    label='Password',
                    rules='required|min:6|confirmed:pass',
                    :value='password',
                    @input='updateState(register, "password", $event)',
                )

                form-field(
                    password-reveal,
                    type='password',
                    label='Password Confirmation',
                    rules='required',
                    vid='pass',
                    :value='confirm',
                    @input='updateState(register, "confirm", $event)',
                )

                b-button.mt-1_5(
                    outlined,
                    expanded,
                    size='is-medium',
                    type='is-primary',
                    native-type='submit',
                ) Sign Up
</template>

<style>
</style>
